import { useEffect, useState, useRef } from "react";
import { Options } from ".";

export interface UseCityBarProps {
  options: Options[];
  onSelect?: (value: string) => void;
  defaultValue?: string;
}

export const useCityBar = ({
  options,
  onSelect,
  defaultValue,
}: UseCityBarProps) => {
  const [defaultOption, setDefaultOption] = useState<Options>(
    options.find((option) => option.slug === defaultValue) || options[0]
  );
  const [filters, setFilters] = useState<Options[]>(options);
  const [trigger, setTrigger] = useState<boolean>(false);
  const boxRef = useRef<HTMLDivElement>(null);
  const [value, setValue] = useState<
    string | number | readonly string[] | undefined
  >("");
  const initOptions = useRef<Options[]>(options);

  useEffect(() => {
    const onMouseClick = (e: MouseEvent): void => {
      if (boxRef.current && !boxRef.current.contains(e?.target as Node)) {
        setValue("");
        setTrigger(false);
        setFilters(initOptions.current);
      }
    };

    document.addEventListener("click", onMouseClick);

    return () => {
      document.removeEventListener("click", onMouseClick);
    };
  }, []);

  useEffect(() => {
    setFilters(options);
  }, [options]);

  const OnOptionSelect = (value: string, option: Options): void => {
    onSelect?.(value);
    setDefaultOption(option);
    setValue("");
    setTrigger(false);
    setFilters([...initOptions.current, option]);
  };

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.currentTarget.value);

    setFilters(
      options.filter((option) =>
        option.label.toLowerCase().includes(e.currentTarget.value.toLowerCase())
      )
    );
  };

  const onClickInput = () => {
    setFilters(initOptions.current);
  };

  return {
    OnOptionSelect,
    defaultOption,
    trigger,
    value,
    boxRef,
    setTrigger,
    setValue,
    onClickInput,
    filters,
    onSearch,
  };
};
